'use client';

import { LoadingBackground } from '@core/Components/LoadingBackground/LoadingBackground';

import { LoadingHeader } from '../../Header/LoadingHeader';
import { CalculatorMessages } from '../Calculator.messages';
import styles from '../Calculator.module.css';
import productToggleStyles from '../ProductToggle/ProductToggle.module.css';

type Props = {
  strings: CalculatorMessages;
};

export const LoadingCalculatorContent = ({ strings }: Props) => {
  return (
    <div className={styles.content}>
      <LoadingHeader strings={strings} />
      <fieldset name="finance products" className={productToggleStyles.financeOptionsType}>
        <LoadingBackground />
      </fieldset>
      <fieldset name="finance products" className={productToggleStyles.financeOptionsType}>
        <LoadingBackground />
      </fieldset>
      <div className={productToggleStyles.divider} />

      <div className={styles.fakeButtons}>
        <div className={styles.fakeButton}>
          <LoadingBackground />
        </div>
        <div className={styles.fakeButton}>
          <LoadingBackground />
        </div>
        <div className={styles.fakeButton}>
          <LoadingBackground />
        </div>
      </div>
    </div>
  );
};
